export const colors = [
    "#2C3E50", // Dark Blue Gray
    "#8B0000", // Dark Red
    "#2F4F4F", // Dark Slate Gray
    "#4B0082", // Indigo
    "#556B2F", // Dark Olive Green
    "#800080", // Purple
    "#A52A2A", // Brown
    "#000080", // Navy
    "#708090", // Slate Gray
    "#483D8B", // Dark Slate Blue
    "#2E8B57", // Sea Green
    "#3C3C3C", // Charcoal
    "#6B8E23", // Olive Drab
    "#4682B4", // Steel Blue
    "#8B4513", // Saddle Brown
  ];
  